export default __webpack_public_path__ + "static/media/3 tharusha.9e7277ac.png";